import React from "react";
import { useContentList } from "../hooks/useContentData";

const POSITIONS = {
  "top-left": "top-0 left-0",
  "top-right": "top-0 right-0",
  "bottom-left": "bottom-0 left-0",
  "bottom-right": "bottom-0 right-0",
};

function safeUrl(value) {
  const url = String(value || "").trim();
  return /^https?:\/\//i.test(url) ? url : "";
}

const FloatingVoteBanners = () => {
  const { items: banners } = useContentList("layout.vote_banners");

  if (banners.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-0 z-[99990]">
      {banners
        .filter((b) => b && b.enabled !== false)
        .map((banner, idx) => {
          const href = safeUrl(banner.href);
          const image = safeUrl(banner.image);
          if (!href || !image) return null;

          const position = POSITIONS[banner.position] || POSITIONS["bottom-right"];
          const width = Math.max(40, Math.min(parseInt(banner.width, 10) || 140, 320));
          const height = Math.max(40, Math.min(parseInt(banner.height, 10) || 120, 260));
          const alt = String(banner.alt || "Vote banner");
          const title = String(banner.title || alt);
          const target = banner.new_tab === false ? undefined : "_blank";

          return (
            <a
              key={`${href}-${idx}`}
              href={href}
              title={title}
              target={target}
              rel={target ? "noopener noreferrer" : undefined}
              className={`pointer-events-auto fixed ${position} block`}
              style={{ width, height, zIndex: 99990 + idx }}
            >
              <img
                src={image}
                alt={alt}
                className="block h-full w-full object-contain border-0"
                loading="lazy"
              />
            </a>
          );
        })}
    </div>
  );
};

export default FloatingVoteBanners;
